export default class Rest {

    id = null;
    name = '';
    description = '';
    username = '';
    userpassword = '';
    token = '';
    webpage = '';
    client = '';
    tokenRequired = 0;

    constructor() {
    }
}